import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignmentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlignmentLeft"><Path d="M3.5 4.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 12H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 19.5H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlignmentLeft;
